import { useEffect } from "react";
import { isDataChanged, hasNonEmptyFiles } from "../../util/FormUtils";

const UnloadPrompt = ({ currentData, originalData, files, setHasUnsavedChanges, isSaving }) => {
    const onBeforeUnload = (e) => {
        if (!isSaving && (isDataChanged(currentData, originalData) || hasNonEmptyFiles(files))) {
            if (setHasUnsavedChanges) {
                setHasUnsavedChanges(true);
            }
            e.preventDefault();
            e.returnValue = "";
        }
    };

    useEffect(() => {
        window.addEventListener("beforeunload", onBeforeUnload);
        return () => {
            window.removeEventListener("beforeunload", onBeforeUnload);
        };
    }, [currentData, originalData, files, isSaving]);

    return null;
};

export default UnloadPrompt;